import React from 'react';
import { Card } from 'primereact/card';
import { ParsedCSVRow } from 'shared';

interface TransactionCardProps {
  row: ParsedCSVRow;
}

export const TransactionCard: React.FC<TransactionCardProps> = ({ row }) => {
  const isIncoming = row.amount > 0;

  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);

  const formatDate = (dateStr: string) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });
  };

  return (
    <Card data-component="bank-import-transaction-card" style={{ marginBottom: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
        <div style={{ flex: '1 1 0', minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '1.1rem', marginBottom: '0.5rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.name || 'Unknown'}</div>
          <div style={{ fontSize: '0.875rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>
            <i className="pi pi-calendar" style={{ marginRight: '0.25rem' }} />
            {formatDate(row.bookingDate)}
            {row.bookingType && <span style={{ marginLeft: '0.5rem' }}>({row.bookingType})</span>}
          </div>
          {row.purpose && (
            <div style={{ fontSize: '0.875rem', color: 'var(--text-color-secondary)', marginTop: '0.5rem', wordBreak: 'break-word' }}>
              {row.purpose}
            </div>
          )}
        </div>
        <div style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
          <span
            style={{ fontSize: '1.25rem', fontWeight: 700, color: isIncoming ? '#22c55e' : '#ef4444' }}
          >
            {isIncoming ? '+' : ''}{formatCurrency(row.amount)}
          </span>
          <div style={{ fontSize: '0.875rem', color: 'var(--text-color-secondary)' }}>{row.currency}</div>
        </div>
      </div>
    </Card>
  );
};
